import qs from "qs";
import NEW_API from "../../Api/NewApi";
import { uploadFile } from "../../Utils";
import { toast } from "react-toastify";
import moment from "moment";
import {
  generateDepositInvoice,
  generateInvoice,
  getCatalogue,
} from "./catalogue";
import axios from "axios";
import { t } from "i18next";

export const fetchCommandes =
  (searchInput, sort = "number:desc", filters, page = 1, activeTab, signal) =>
  async (dispatch) => {
    const token = localStorage.getItem("token");
    NEW_API.defaults.headers.common["Authorization"] = token;
    try {
      const reseller = filters?.reseller
        ? `&reseller=${filters?.reseller}`
        : "";
      const businessAffiliate = filters?.businessAffiliate
        ? `&businessAffiliate=${filters?.businessAffiliate}`
        : "";
      const searchquery = searchInput ? `search=${searchInput}` : "";
      const sortquery = sort ? `sort=${sort}` : "";
      if (page === 1) {
        dispatch({ type: "COMMANDES_LOADING" });
      } else {
        dispatch({ type: "COMMANDES_REFETCH_LOADING" });
      }

      const { data } = await NEW_API.get(
        `/api/fetchCommandes?${searchquery}&${sortquery}&page=${page}&activeTab=${activeTab}${reseller}${businessAffiliate}`,
        { signal },
      );

      if (page === 1) {
        dispatch({
          type: "COMMANDES_SUCCESS",
          payload: { commandes: data.data.commandes, count: data.data.count },
        });
      } else {
        dispatch({
          type: "COMMANDES_SUCCESS_REFETCH",
          payload: data.data.commandes,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: "COMMANDES_ERROR" });
    }
  };

export const updatePreviousValues =
  (packings, deliveryPrice, id) => async (dispatch) => {
    try {
      await NEW_API.put(`/api/commandes/${id}`, {
        data: { previousValues: { packings, deliveryPrice } },
      });
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const updateCommande =
  (commandeId, data, packings) => async (dispatch) => {
    try {
      await NEW_API.put(`/api/commandes/${commandeId}`, {
        data: { ...data },
      });
      if (data?.status && packings?.length > 0) {
        await NEW_API.put(`/api/update-packing-status`, {
          data: { packings },
        });
      }
      dispatch(refetchCommandeItem(commandeId));
    } catch (error) {
      dispatch({ type: "CART_ERROR" });
    }
  };

export const fetchCommande = (commandeId) => async (dispatch) => {
  dispatch({ type: "COMMANDES_LOADING" });

  try {
    const fetchedCommande = await NEW_API.get(
      `/api/fetchCommandeItem?commandeId=${commandeId}`,
    );
    dispatch({
      type: "COMMANDE_SUCCESS",
      payload: fetchedCommande?.data?.data,
    });
  } catch (error) {
    dispatch({ type: "COMMANDES_ERROR" });
  }
};

export const refetchCommandeItem = (commandeId) => async (dispatch) => {
  try {
    const newCommande = await NEW_API.get(
      `/api/fetchCommandeItem?commandeId=${commandeId}`,
    );
    dispatch({
      type: "UPDATE_COMMANDE",
      payload: {
        commandeId: commandeId,
        data: newCommande.data.data.commande,
      },
    });
  } catch (error) {
    dispatch({ type: "CART_ERROR" });
  }
};

export const deleteCommande =
  (commandeId, { searchInput, activeTab, productsactiveTab }) =>
  async (dispatch) => {
    try {
      await NEW_API.post(`/api/handleDeleteCommande`, {
        data: { commandeId: commandeId },
      });
      dispatch({
        type: "DELETE_COMMANDE",
        payload: commandeId,
      });
      if (activeTab && productsactiveTab) {
        dispatch(getCatalogue(activeTab, productsactiveTab, searchInput));
      }
    } catch (error) {
      if (error?.response?.status === 409) {
        toast.error(
          t(
            "This cart holds the units of your customer's order: cancel that order on the client sheet first.",
          ),
        );
      }
      dispatch({ type: "CART_ERROR" });
    }
  };

// COMMENTS

export const getOrderComments = (order) => async (dispatch) => {
  try {
    dispatch({ type: "FETCH_COMMENTS_ORDER_LOADING" });
    const {
      data: { data: commentData },
    } = await NEW_API.get(`/api/comments`, {
      params: {
        populate: {
          attachments: {
            populate: {
              file: true,
            },
          },
          emojis: {
            populate: {
              user: true,
            },
            sort: ["createdAt:desc"],
          },
          user: {
            populate: {
              photo: true,
              marque: true,
              business_affiliate: true,
              profil: {
                populate: {
                  reseller: true,
                },
              },
            },
          },
        },
        sort: ["createdAt:desc"],
        filters: {
          commande: { id: { $eq: order } },
        },
      },
    });
    dispatch({ type: "FETCH_COMMENTS_ORDER_SUCCESS", payload: commentData });
  } catch (error) {
    dispatch({ type: "FETCH_COMMENTS_ORDER_ERROR", payload: error });
  }
};

export const createOrderComment =
  (comment, order, user, successCallback, t) => async (dispatch) => {
    dispatch({ type: "CREATE_COMMENTS_ORDER_LOADING" });

    try {
      const {
        data: { data: commentData },
      } = await NEW_API.post(`/api/comments?populate=*`, {
        data: {
          text: comment?.text,
          commande: order,
          user,
        },
      });

      if (comment?.attachments?.length > 0) {
        for (const file of comment?.attachments) {
          const fileId = await uploadFile(file);
          const { data } = await NEW_API.post(`/api/attachments?populate=*`, {
            data: {
              date: new Date(),
              file: fileId,
              comment: commentData?.id,
            },
          });
          commentData.attributes.attachments.data?.push(data?.data);
        }
      }

      dispatch({
        type: "CREATE_COMMENTS_ORDER_SUCCESS",
        payload: {
          ...commentData,
          attributes: { ...commentData?.attributes },
        },
      });
      successCallback();
      toast.success(t("A comment has been added"));
    } catch (error) {
      console.log(error);
    }
  };

export const updateCommandePayments =
  (commande) => async (dispatch, getState) => {
    dispatch({ type: "UPDATE_COMMANDE_PAY_LOADING" });
    dispatch({ type: "COMMANDES_LOADING" });

    const { commande: currentCommande } = getState().commandeReducer;

    try {
      const sumPaiements = commande?.payments
        ?.reduce((acc, { amount }) => acc + +amount, 0)
        ?.toFixed(2);
      const { user } = getState().userReducer;

      let lastDepositAmount = 0;

      if (commande?.payments) {
        for (const payment of commande?.payments) {
          let paymentId;

          if (payment?.newPayment) {
            const paymentCreated = await NEW_API.post(`api/payments`, {
              data: {
                amount: payment?.amount,
                date: moment(payment?.date).format("YYYY-MM-DD"),
                commande: commande?.id,
              },
            });

            paymentId = paymentCreated?.data?.data?.id;
            if (+sumPaiements === +commande?.totalTTC?.toFixed(2))
              lastDepositAmount = +payment?.amount;

            if (paymentId) {
              if (
                +sumPaiements !== +commande?.totalTTC?.toFixed(2) ||
                (+sumPaiements === +commande?.totalTTC?.toFixed(2) &&
                  commande?.payments?.length > 1)
              ) {
                await dispatch(
                  generateDepositInvoice(
                    commande?.id,
                    paymentId,
                    true,
                    t,
                    lastDepositAmount,
                  ),
                );

                await NEW_API.post(`api/sendMailPay`, {
                  data: {
                    amount: +payment?.amount,
                    id: commande?.id,
                    userEmail: user?.attributes?.email, // changedddddd
                    paymentId,
                  },
                });
              }
            }
          } else {
            if (+sumPaiements === +commande?.totalTTC?.toFixed(2)) {
              lastDepositAmount = +payment?.amount;
            }

            await NEW_API.put(`api/payments/${payment?.id}`, {
              data: {
                amount: payment.amount,
                date: moment(payment.date).format("YYYY-MM-DD"),
              },
            });

            if (payment?.acompte_facture?.id) {
              await NEW_API.put(
                `api/acompte-factures/${payment?.acompte_facture?.id}`,
                {
                  data: {
                    number: payment?.acompte_facture?.number,
                    date: moment(payment?.acompte_facture?.date).format(
                      "YYYY-MM-DD",
                    ),
                  },
                },
              );
            } else if (commande?.facture) {
              await NEW_API.put(`api/commandes/${commande?.id}`, {
                data: {
                  factureNumber: commande?.factureNumber,
                  factureDate: moment(commande?.factureDate).format(
                    "YYYY-MM-DD",
                  ),
                },
              });
              await NEW_API.put(`api/factures/${commande?.facture?.id}`, {
                data: {
                  number: commande?.facture?.number,
                  date: moment(commande?.facture?.date).format("YYYY-MM-DD"),
                },
              });
            }
            paymentId = +payment?.id;

            if (paymentId) {
              if (
                +sumPaiements !== +commande?.totalTTC?.toFixed(2) ||
                (+sumPaiements === +commande?.totalTTC?.toFixed(2) &&
                  commande?.payments?.length > 1)
              ) {
                await dispatch(
                  generateDepositInvoice(
                    commande?.id,
                    paymentId,
                    true,
                    t,
                    lastDepositAmount,
                  ),
                );
              }

              const paymentHasChanged =
                +currentCommande?.payments?.find((p) => p?.id === payment?.id)
                  ?.amount !== +payment?.amount;

              if (paymentHasChanged) {
                await NEW_API.post(`api/sendMailPay`, {
                  data: {
                    amount: +payment?.amount,
                    id: commande?.id,
                    userEmail: user?.attributes?.email,
                    paymentId,
                  },
                });
              }
            }
          }
        }

        if (+sumPaiements === +commande?.totalTTC?.toFixed(2)) {
          await NEW_API.put(`api/commandes/${commande?.id}`, {
            data: {
              payStatus: "Payée",
              status:
                commande?.status === "Brouillon"
                  ? "En Cours"
                  : commande?.status,
            },
          });
        } else {
          if (commande?.payments?.length === 1) {
            await NEW_API.put(`api/commandes/${commande?.id}`, {
              data: { payStatus: "Acompte payé", status: "En Cours" },
            });
          }
        }
      }

      if (
        +commande?.totalTTC?.toFixed(2) === +sumPaiements &&
        commande?.payments?.length === 1
      ) {
        const payment = commande?.payments[0];
        await dispatch(generateInvoice(commande?.id, true, t));

        const paymentHasChanged =
          +currentCommande?.payments?.find((p) => p?.id === payment?.id)
            ?.amount !== +payment?.amount;

        if (paymentHasChanged) {
          await NEW_API.post(`api/sendMailPay`, {
            data: {
              amount: +payment?.amount,
              id: commande?.id,
              userEmail: user?.attributes?.email,
              paymentId: payment.id,
            },
          });
        }
      }

      dispatch(refetchCommandeItem(commande?.id));

      dispatch(fetchCommande(commande?.id));
      dispatch({ type: "UPDATE_COMMANDE_PAY_SUCC" });
    } catch (error) {
      console.log(error);
      dispatch({ type: "CART_ERROR" });
    }
  };

export const deletePayment = (payload) => async (dispatch) => {
  dispatch({ type: "ORDER_LOADING" });
  try {
    await NEW_API.delete(`api/payments/${payload.id}`);

    await dispatch(fetchCommande(payload?.commandeID));
    payload?.callBack && payload?.callBack(payload.id);
  } catch (error) {
    console.log(error);
    dispatch({ type: "ORDER_ERROR", payload: error });
  }
};

export const payOrder = (payload) => async (dispatch) => {
  dispatch({ type: "PAY_ORDER_LOADING" });
  try {
    const response = await axios.post(
      "https://up2pay-tg.tendances.group/api/checkout",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.data.paymentForm) {
      console.log("Invalid payment response received");
    }

    // Create a temporary div and inject the payment form
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = response.data.paymentForm;
    document.body.appendChild(tempDiv);

    const form = tempDiv.querySelector("form");
    if (form) {
      form.submit();
    } else {
      throw new Error("Payment form not found in response");
    }

    dispatch({ type: "PAY_ORDER_SUCC" });
  } catch (error) {
    console.log(error);
    toast.error(t("Payment processing failed. Please try again."));
    dispatch({ type: "PAY_ORDER_FAIL" });
  }
};

export const sendDepositMail = (commandeId, t) => async () => {
  const token = localStorage.getItem("token");
  NEW_API.defaults.headers.common["Authorization"] = token;
  try {
    await NEW_API.post(`/api/sendDepositMail`, { data: { commandeId } });
    toast.success(t("Deposit email sent successfully"));
  } catch (error) {
    console.log(error);
    toast.error(t("Failed to send deposit email"));
  }
};

export const sendFullPaymentMail = (commandeId, t) => async () => {
  const token = localStorage.getItem("token");
  NEW_API.defaults.headers.common["Authorization"] = token;
  try {
    await NEW_API.post(`/api/sendFullPaymentMail`, { data: { commandeId } });
    toast.success(t("Full payment email sent successfully"));
  } catch (error) {
    console.log(error);
    toast.error(t("Failed to send full payment email"));
  }
};

export const sendBalanceMail = (commandeId, t) => async () => {
  const token = localStorage.getItem("token");
  NEW_API.defaults.headers.common["Authorization"] = token;
  try {
    await NEW_API.post(`/api/sendBalanceMail`, { data: { commandeId } });
    toast.success(t("Balance email sent successfully"));
  } catch (error) {
    console.log(error);
    toast.error(t("Failed to send balance email"));
  }
};
